import React from 'react';

const XClose = ({label, onClick, buttonClass, id}) => {
  return (
    <button type='button' className={`btn-link close ${buttonClass}`} onClick={onClick} id={id}>
      <span><i aria-label={label} className='icon-x' /></span>
    </button>
  );
};


export default XClose;
